import script from "./PurchaseSquareHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseSquareHeader.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseSquareHeader.vue?vue&type=style&index=0&id=0af6b94d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af6b94d"]])

export default __exports__